import api from './api';

// Helper function to check if it's a network error
const isNetworkError = (error: any): boolean => {
  return !error.response && (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error') || error.message?.includes('ERR_NETWORK'));
};

export interface ProcessDataRequest {
  entityId: string; // Required: entity ID to process
  data: string; // Required: text data to process
}

export interface ProcessDataResponse {
  status: string;
  message: string;
  data: {
    processed_entities: number;
    processed_files: number;
    processed_urls: number;
    processing_time: number;
    errors: string[];
    warnings: string[];
  };
}

export const dataProcessingApi = {
  // Manually process raw data for a specific entity
  processData: async (request: ProcessDataRequest): Promise<ProcessDataResponse> => {
    try {
      console.log('Request object:', request);
      console.log('request.data:', request.data);
      console.log('request.data type:', typeof request.data);
      console.log('request.data length:', request.data?.length);
      
      const requestBody = { data: request.data };
      console.log('Sending request:', {
        url: `/entity/${request.entityId}/process`,
        body: requestBody
      });
      
      const response = await api.post(`/entity/${request.entityId}/process`, requestBody);
      return response.data;
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw new Error(error.response?.data?.detail || 'Failed to process data');
    }
  },

  // Get processing status
  getProcessingStatus: async (): Promise<any> => {
    try {
      const response = await api.get('/process-data/status');
      return response.data;
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw new Error(error.response?.data?.detail || 'Failed to get processing status');
    }
  },

  // Get processing history
  getProcessingHistory: async (): Promise<any> => {
    try {
      const response = await api.get('/process-data/history');
      return response.data;
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw new Error(error.response?.data?.detail || 'Failed to get processing history');
    }
  },
};
